export const DEFAULT_STALE_TIME = 5 * 60 * 1000;
